import addMenues_store from './components/addMenus.js'
import addRoutes_store from './components/addRoutes.js'
import addUserInfo_store from './components/userInfo.js'

export default {
  menu: addMenues_store,
  route: addRoutes_store,
  user: addUserInfo_store

}
